import logo from "../assets/images/logo512.png";
import React, { useEffect, useState } from "react";
import {
  FaEnvelope,
  FaStore,
  FaPhone,
  FaSms,
  FaWhatsapp,
  FaReact,
} from "react-icons/fa";

function DefualtCard() {
  const [contactFileUrl, setContactFileUrl] = useState(null);

  useEffect(() => {
    // Create vCard content
    const vcfData = [
      "BEGIN:VCARD",
      "VERSION:3.0",
      "FN:Zeedcom",
      "ORG:Zeedcom",
      "TEL;TYPE=WORK,VOICE:+213778123778",
      "EMAIL;TYPE=WORK:contact.zeedcom@gmail.com",
      "URL:https://zeedcomapp.web.app/",
      "PHOTO;VALUE=URI;TYPE=PNG:https://zeedcomapp.web.app/logo512.png",
      "END:VCARD",
    ].join("\r\n");

    // Create a Blob from the vCard
    const blob = new Blob([vcfData], {
      type: "text/vcard;charset=utf-8",
    });

    // Create temporary URL
    const url = URL.createObjectURL(blob);

    setContactFileUrl(url);

    // Cleanup Blob URL when component is unmounted
    return () => {
      URL.revokeObjectURL(url);
    };
  }, []);

  return (
    <div className="mx-auto max-w-xl overflow-hidden rounded-lg bg-white shadow-lg">
      {/* Header */}
      <div className="relative rounded-b-[20px] bg-blue-600 text-white">
        <div className="flex h-[130px] justify-center"></div>

        {/* Logo */}
        <div className="absolute inset-x-0 -bottom-16 flex justify-center">
          <img
            className="h-32 w-32 rounded-full border-4 border-white bg-blue-600 object-cover"
            src={logo}
            alt="Zeedcom"
          />
        </div>
      </div>

      {/* Company Information */}
      <div className="px-6 pb-6 pt-16 text-center">
        <h2 className="text-xl font-semibold text-blue-600">
          Zeedcom
        </h2>

        <p className="text-sm text-blue-600">
          Software Company
        </p>

        <p className="mt-2 text-sm text-gray-700">
          We use technology to make businesses more efficient,
          connected, and productive.
        </p>
      </div>

      {/* Social Media */}
      <div className="flex w-full justify-center gap-8 pb-5 pt-5">
        {/* Facebook */}
        <a
          href="https://www.facebook.com/ZeedComApp"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Facebook"
          className="text-gray-500 transition-colors hover:text-blue-600"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-10 w-10"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M12 2.03998C6.5 2.03998 2 6.52998 2 12.06C2 17.06 5.66 21.21 10.44 21.96V14.96H7.9V12.06H10.44V9.84998C10.44 7.33998 11.93 5.95998 14.22 5.95998C15.31 5.95998 16.45 6.14998 16.45 6.14998V8.61998H15.19C13.95 8.61998 13.56 9.38998 13.56 10.18V12.06H16.34L15.89 14.96H13.56V21.96C15.9164 21.5878 18.0622 20.3855 19.6099 18.57C21.1576 16.7546 22.0054 14.4456 22 12.06C22 6.52998 17.5 2.03998 12 2.03998Z" />
          </svg>
        </a>

        {/* Instagram */}
        <a
          href="https://www.instagram.com/zeedcomapp"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Instagram"
          className="text-gray-500 transition-colors hover:text-pink-500"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-10 w-10"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <rect
              x="2"
              y="2"
              width="20"
              height="20"
              rx="5"
              ry="5"
            />
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
            <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
          </svg>
        </a>

        {/* TikTok */}
        <a
          href="https://www.tiktok.com/@zeedcomapp"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="TikTok"
          className="text-gray-500 transition-colors hover:text-black"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-10 w-10"
            viewBox="0 0 256 256"
            fill="none"
            stroke="currentColor"
            strokeWidth="20"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M216.26,79.61c-14.3-1.43-27-8.57-35.33-19.38a57.45,57.45,0,0,1-11-32.66H141.3V173.43a27.36,27.36,0,1,1-18.47-26v-33a60.33,60.33,0,0,0-29.33-3.26C71,116.71,52.57,133,48.13,154.77a66.2,66.2,0,0,0,29.67,67.86,65.11,65.11,0,0,0,32,8.53c36.33,0,65.87-29.62,65.87-66V93.13a89.38,89.38,0,0,0,47.28,14.13V79.61Z" />
          </svg>
        </a>
      </div>

      {/* Contact Links */}
      <ul className="divide-y divide-gray-100 px-10">
        {/* Website */}
        <li>
          <a
            href="https://zeedcomapp.web.app"
            target="_blank"
            rel="noopener noreferrer"
            className="flex justify-between gap-x-6 py-3"
          >
            <div className="flex min-w-0 gap-x-4">
              <FaReact className="text-5xl text-blue-600" />

              <div className="min-w-0 flex-auto text-left">
                <p className="text-lg font-semibold leading-6 text-gray-900">
                  Website
                </p>

                <p className="mt-1 truncate text-base leading-5 text-gray-500">
                  Zeedcom Services
                </p>
              </div>
            </div>
          </a>
        </li>

        {/* Store */}
        <li>
          <a
            href="https://ecommerce-alpha-seven-96.vercel.app/"
            target="_blank"
            rel="noopener noreferrer"
            className="flex justify-between gap-x-6 py-3"
          >
            <div className="flex min-w-0 gap-x-4">
              <FaStore className="text-5xl text-blue-600" />

              <div className="min-w-0 flex-auto text-left">
                <p className="text-lg font-semibold leading-6 text-gray-900">
                  Store
                </p>

                <p className="mt-1 truncate text-base leading-5 text-gray-500">
                  Zeedcom Products
                </p>
              </div>
            </div>
          </a>
        </li>

        {/* Phone */}
        <li>
          <a
            href="tel:+213778123778"
            className="flex justify-between gap-x-6 py-3"
          >
            <div className="flex min-w-0 gap-x-4">
              <FaPhone className="text-5xl text-blue-600" />

              <div className="min-w-0 flex-auto text-left">
                <p className="text-lg font-semibold leading-6 text-gray-900">
                  Call
                </p>

                <p className="mt-1 truncate text-base leading-5 text-gray-500">
                  +213 778 123 778
                </p>
              </div>
            </div>
          </a>
        </li>

        {/* WhatsApp */}
        <li>
          <a
            href="https://wa.me/213778123778"
            target="_blank"
            rel="noopener noreferrer"
            className="flex justify-between gap-x-6 py-3"
          >
            <div className="flex min-w-0 gap-x-4">
              <FaWhatsapp className="text-5xl text-blue-600" />

              <div className="min-w-0 flex-auto text-left">
                <p className="text-lg font-semibold leading-6 text-gray-900">
                  WhatsApp
                </p>

                <p className="mt-1 truncate text-base leading-5 text-gray-500">
                  +213 778 123 778
                </p>
              </div>
            </div>
          </a>
        </li>

        {/* SMS */}
        <li>
          <a
            href="sms:+213778123778"
            className="flex justify-between gap-x-6 py-3"
          >
            <div className="flex min-w-0 gap-x-4">
              <FaSms className="text-5xl text-blue-600" />

              <div className="min-w-0 flex-auto text-left">
                <p className="text-lg font-semibold leading-6 text-gray-900">
                  SMS
                </p>

                <p className="mt-1 truncate text-base leading-5 text-gray-500">
                  +213 778 123 778
                </p>
              </div>
            </div>
          </a>
        </li>

        {/* Email */}
        <li>
          <a
            href="mailto:contact.zeedcom@gmail.com"
            className="flex justify-between gap-x-6 py-3"
          >
            <div className="flex min-w-0 gap-x-4">
              <FaEnvelope className="text-5xl text-blue-600" />

              <div className="min-w-0 flex-auto text-left">
                <p className="text-lg font-semibold leading-6 text-gray-900">
                  Email
                </p>

                <p className="mt-1 truncate text-base leading-5 text-gray-500">
                  contact.zeedcom@gmail.com
                </p>
              </div>
            </div>
          </a>
        </li>
      </ul>

      {/* Add to Contacts */}
      <a
        className={`mt-4 block w-full px-8 pb-4 pt-3 text-center text-sm text-white ${
          contactFileUrl
            ? "bg-blue-600 hover:bg-blue-700"
            : "cursor-not-allowed bg-gray-400"
        }`}
        href={contactFileUrl ?? "#"}
        download="Zeedcom.vcf"
        onClick={(event) => {
          if (!contactFileUrl) {
            event.preventDefault();
          }
        }}
      >
        Add to Contact
      </a>
    </div>
  );
}

export default DefualtCard;
